"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorage = exports.sessionStorage = exports.cookie = void 0;
var sessionStorage = require("./src/session-storage");
exports.sessionStorage = sessionStorage;
var localStorage = require("./src/local-storage");
exports.localStorage = localStorage;
var cookie = require("./src/cookie");
exports.cookie = cookie;
